<script>
import cloneDeep from 'lodash/cloneDeep'
import tourMixin from '@src/mixins/tour'
import { authComputed, merchantComputed } from '@state/helpers'
import lazyLoadComponent from '@router/lazyload-component'
import { cities as TaiwanCity } from '@utils/taiwan-city-area'
import { taiwanCitys, districtsFilter, findDistrictZip } from '@utils/filter-value-to-text'

import taiwanBankCode from '@utils/taiwan-bank-code'

const minutesOfTime = (time = '00:00') => {
  const timeMatches = time.match(/^(\d+):(\d+)$/i)
  const [, hours, minutes] = timeMatches
  return Number(hours) * 60 + Number(minutes)
}

const initData = () => {
  return {
    phoneCode: '+886',
    phone: '',
    state: 2,
    hidden: 0,
    name: '',
    alias: '',
    type: '',
    description: '',
    notice: '',
    location: {
      name: '',
      country: '臺灣',
      city: '',
      address: '',
      district: '',
    },
    staffs: [],
    introimage: '',
    image: '',
    images: [],
    video: '',
    orderExtrafields: [],
    allowOverlap: 0,
    autoSpaceEnabled: 0,
    showPrice: 1,
    lineId: '',
    lineFriendUrl: '',
    fbFanpageUrl: '',
    lat: '',
    lng: '',
    storeType: ''
  }
}
export default {
  components: {
    BaseInputFloatingLabel: () => lazyLoadComponent(import('@components/BaseInputFloatingLabel')),
    ServiceAreaItem: () => lazyLoadComponent(import('./ServiceAreaItem')),
    CountryCodePicker: () => lazyLoadComponent(import('@components/CountryCodePicker')),
    BaseUpload: () => lazyLoadComponent(import('@components/BaseUpload')),
    ImageUpload: () => lazyLoadComponent(import('@views/chat/components/FileUpload')),
  },
  mixins: [tourMixin],
  tourName: 'productBasic',
  props: {
    itemType: {
      type: String,
      required: true,
    },
    defaultValue: {
      type: Object,
      default: () => initData(),
    },
  },
  data() {
    return {
      socialChecked: false,
      noticeChecked: false,
      taiwanCitys,
      sameAsMerchant: true,
      merchantInfo: {},
      TaiwanCityList: Object.freeze(TaiwanCity),
      submitData: cloneDeep(Object.assign({}, initData(), this.defaultValue)),
      submitRules: {
        name: [
          {
            required: true,
            message: '請填寫名稱',
            trigger: 'blur',
          },
        ],
        phone: [
          {
            required: true,
            message: '請填寫聯絡電話',
            trigger: 'blur',
          },
        ],
        // alias: [
        //   {
        //     required: true,
        //     message: '請填寫別名',
        //     trigger: 'blur',
        //   },
        //   {
        //     pattern: /^[a-zA-Z0-9-]+$/,
        //     message: '請使用英文大小寫字母、數字或英文半形連字號組合',
        //     trigger: 'blur',
        //   },
        // ],
        description: [
          {
            required: true,
            message: '請填寫描述',
            trigger: 'blur',
          },
        ],
        'location.name': [
          {
            required: true,
            message: '請填寫地點名稱',
            trigger: 'blur',
          },
        ],
        // 'location.country': [
        //   {
        //     required: true,
        //     message: '請選擇國家',
        //     trigger: 'change',
        //   },
        // ],
        'location.city': [
          {
            required: true,
            message: '請選擇城市',
            trigger: 'change',
          },
        ],
        'location.district': [
          {
            required: true,
            message: '請選擇區域',
            trigger: 'change',
          },
        ],
        'location.address': [
          {
            required: true,
            message: '請輸入地址',
            trigger: 'blur',
          },
        ],
        // video: [
        //   {
        //     pattern: /^(https?:\/\/)?(www\.)?(youtube\.com|youtu\.?be)\/.+$/,
        //     message: '請輸入有效的 YouTube 影片網址',
        //     trigger: 'blur',
        //   },
        // ],
        atmAccount: [
          {
            message: '請輸入帳號',
            required: true,
            trigger: 'blur',
          },
        ],
        atmBank: [
          {
            message: '請輸入匯款銀行',
            required: true,
            trigger: 'blur',
          },
        ],
        atmAccountName: [
          {
            message: '請輸入戶名',
            required: true,
            trigger: 'blur',
          },
        ],
        'addressRestrictions.city': [
          {
            required: true,
            message: '請選擇城市',
            trigger: 'blur',
          },
        ],
        'addressRestrictions.district': [
          {
            required: true,
            message: '請選擇區域',
            trigger: 'blur',
          },
        ],
        // 'serviceTimeSetting.start': [
        //   {
        //     required: true,
        //     validator: (rule, value, callback) => {
        //       if (!value) return callback(new Error('請選擇營業開始時間'))
        //       if (this.submitData.serviceTimeSetting.end) this.$refs.form.validateField('serviceTimeSetting.end')

        //       callback()
        //     },
        //     trigger: 'change',
        //   },
        // ],
        // 'serviceTimeSetting.end': [
        //   {
        //     required: true,
        //     validator: (rule, value, callback) => {
        //       const { start } = this.submitData.serviceTimeSetting
        //       if (minutesOfTime(start) >= minutesOfTime(value)) return callback(new Error('結束時間不可早於開始時間'))
        //       callback()
        //     },
        //     trigger: 'change',
        //   },
        // ],
        // 'serviceTimeSetting.lastOrder': [
        //   {
        //     required: true,
        //     message: '請選擇時間',
        //     trigger: 'change',
        //   },
        // ],
        // 'serviceTimeSetting.beforehandOrder': [
        //   {
        //     required: true,
        //     message: '請輸入提前預約時間',
        //   },
        // ],
      },
      taiwanBankCode,
    }
  },
  watch: {
    infoChecked(value) {
      if (value) {
        this.getMerchant('info')
      }
    },
    'submitData.image': {
      handler(value) {
        if (value) {
          this.submitData.images = [{
            type: 'image',
            path: value,

          }]
        } else {
          this.submitData.images = []
        }
      },
    },
    'submitData.state': {
      handler(nvl) {
      }
    }
    // 'submitData.location.address': {
    //   handler(value) {
    //     this.geocode()
    //   },
    // },
  },
  computed: {
    ...authComputed,
    ...merchantComputed,
    // productBaseBookingUrl() {
    //   return `${this.merchantUrl}/product/`
    // },
    productBaseBookingUrl() {
      const prefixUrl = this.merchantUrl.split('//', 2)
      return `${prefixUrl[0]}//${this.currentMerchant.alias}.${prefixUrl[1]}`
    },
    storeBaseUrl() {
      if (this.$hasHomeService()) {
        return `${this.productBaseBookingUrl}/store/`
      } else {
        return `${this.productBaseBookingUrl}/reservation?store=`
      }
    },
    isEditMode() {
      return this.defaultValue.id
    },
    filteredCity() {
      const selectedCitys = this.submitData.addressRestrictions.map((res) => res.city)
      return taiwanCitys.filter((city) => {
        return !selectedCitys.includes(city.name)
      })
    },
    districts() {
      return districtsFilter(this.submitData.location.city)
    },
    isHomeService() {
      return this.defaultValue.storeType === 'home'
    },
    formatSubmitData() {
      // const { images, categoryIds } = this.submitData
      const { images } = this.submitData
      return {
        ...this.submitData,
        images: images.map((image, index) => {
          return {
            ...image,
            default: index === 0 ? 1 : 0,
          }
        }),
        // categoryIds: [categoryIds],
      }
    },
  },

  created() {
    !this.isEditMode || (this.isEditMode && !this.submitData.orderExtrafields.byProduct)
      ? this.requestExtraFieldbyProduct()
      : this.updateExtraFieldbyProduct(this.submitData.orderExtrafields.byProduct)
    !this.isEditMode && this.tryToFetchMerchant()

    // if (this.isEditMode && !this.submitData.params.serviceTimeSetting) {
    //   this.submitData.params = {
    //     addressRestrictions: [
    //       {
    //         city: '',
    //         region: [],
    //       },
    //     ],
    //     serviceTimeSetting: {
    //       start: '',
    //       end: '',
    //       lastOrder: '',
    //       beforehandOrder: 0,
    //     },
    //   }
    // }
  },
  methods: {
    validate() {
      return this.$refs.form.validate()
    },
    async requestExtraFieldbyProduct() {
      const extraFieldData = await this.$store.dispatch('product/fetchExtraField', {
        typeByProduct: this.itemType,
        paginate: 0
      })
      const filterData = extraFieldData.map((field) => {
        const { id, title, value, required } = field
        return {
          id,
          title,
          value,
          required,
        }
      })
      this.updateExtraFieldbyProduct([...filterData])
    },
    updateExtraFieldbyProduct(value) {
      this.submitData.orderExtrafields = value
    },
    async tryToFetchMerchant() {
      const data = await this.$store.dispatch('merchant/fetchSingle')
      this.merchantInfo = { ...data }
      // this.submitData.location.name = data.name
      // this.submitData.location.city = data.city
      // this.submitData.location.address = data.address
    },
    /**
     * 
     * @param {*} id 
     */
    async loadPage(id) {
      const data = await this.$store.dispatch('product/fetchSingle', id)
      this.$set(this.submitData, 'alias', data.alias)
    },
    onChange(checked) {
      if (checked) {
        this.submitData.location.name = this.merchantInfo.name
        this.submitData.location.city = this.merchantInfo.city
        this.submitData.location.address = this.merchantInfo.address
      } else {
        this.submitData.location.name = ''
        this.submitData.location.city = ''
        this.submitData.location.address = ''
      }
    },
    onRemoveServiceArea(index) {
      this.submitData.addressRestrictions.splice(index, 1)
    },
    onAddServiceArea() {
      this.submitData.addressRestrictions.push({
        city: '',
        district: [],
      })
    },
    onSelectCity() {
      this.submitData.location.district = ''
    },
    async getMerchant(type) {
      const { name, description, phoneCode, phoneNumber,
        email, city, district, address } = await this.$store.dispatch('merchant/fetchSingle')
      if (type === 'info') {
        this.submitData.name = name
        this.submitData.description = description
        this.submitData.phoneCode = phoneCode
        this.submitData.phone = phoneNumber
        this.submitData.email = email
        this.submitData.location.city = city
        this.submitData.location.district = district
        this.submitData.location.address = address
      }
    },
    async setDefaultMerchant() {
      const { atmAccount, atmBank, atmAccountName } = await this.$store.dispatch('merchant/fetchSingle')
      this.$set(this.submitData, 'atmAccount', atmAccount)
      this.$set(this.submitData, 'atmBank', atmBank)
      this.$set(this.submitData, 'atmAccountName', atmAccountName)
    },

    // onSelectDistrict() {
    //   const { city, region } = this.submitData
    //   this.submitData.postcode = findDistrictZip(city, region)
    // },
  },
}
</script>

<template>
  <el-form ref="form" :model="submitData" :rules="submitRules" label-position="top" class="el-form--floating"
    :class="$style.editProduct">
    <div>
      <el-row style="height:50px;">
        <el-col :span="24" class="openService">
          <h4>是否啟用分店</h4>
          <el-switch v-model="submitData.state" active-text="是" inactive-text="否" :active-value="1" :inactive-value="0">
          </el-switch>
        </el-col>
      </el-row>

      <el-row v-if="$hasSpaceModule()" style="height:50px;">
        <el-col :span="24" class="openService">
          <h4>是否啟用空間搜尋？</h4>
          <el-switch v-model="submitData.autoSpaceEnabled" active-text="是" inactive-text="否" :active-value="1" :inactive-value="0">
          </el-switch>
        </el-col>
        <p style="color: #F25555">若空間設定人數大於1位，系統還是會默認空間設定人數為1</p>
      </el-row>

    </div>
    <el-divider></el-divider>
    <el-row :gutter="20">
      <el-col :sm="12" :span="24">
        <el-form-item label="分店名稱" prop="name">
          <el-input v-model="submitData.name" class="bg-white is-rounded is-border" />
        </el-form-item>
      </el-col>
      <el-col :sm="12" :span="24">
        <el-form-item label="聯絡電話" prop="phone">
          <el-input v-model="submitData.phone"
            class="is-border is-rounded bg-white is-short-input is-group__prepend-border">
            <CountryCodePicker slot="prepend" v-model="submitData.phoneCode" />
          </el-input>
        </el-form-item>
      </el-col>
    </el-row>

    <el-form-item :label="$root.isSmallDevice ? `分店網址: ${storeBaseUrl}` : '分店網址'" prop="alias">
      <el-input v-model="submitData.alias" placeholder="請使用英文字母與數字組合" class="is-border is-rounded bg-white">
        <template v-if="!$root.isSmallDevice" v-slot:prepend>{{ storeBaseUrl }}</template>
      </el-input>
    </el-form-item>



    <template v-if="isHomeService && $hasHomeService()">
      <div style="margin-bottom:20px">
        <h4 class="form-block-title">服務區域</h4>
        <ServiceAreaItem v-for="(restriction, index) in submitData.addressRestrictions" :key="`restriction-${index}`"
          :item-index="index" :default-value="restriction" :citys="filteredCity"
          :show-remove="submitData.addressRestrictions.length > 1" @remove="onRemoveServiceArea"></ServiceAreaItem>
        <el-button type="primary" class="is-round is-border is-fullwidth" style="margin-top: 30px" plain
          :disabled="taiwanCitys.length === submitData.addressRestrictions.length" @click="onAddServiceArea">
          <BaseIcon name="plus"></BaseIcon> 新增服務區域{{ taiwanCitys.length === submitData.addressRestrictions.length ?
              '（已選擇全部區域）' : ''
          }}
        </el-button>
      </div>
    </template>
    <template v-else>
      <el-row :gutter="20">
        <el-col :md="6">
          <el-form-item label="縣市" prop="location.city">
            <el-select v-model="submitData.location.city" filterable placeholder="請選擇" @change="onSelectCity">
              <el-option v-for="(city, index) in taiwanCitys" :key="index" :label="city.name" :value="city.name">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :md="6">
          <el-form-item label="區域" prop="location.district">
            <el-select v-model="submitData.location.district" placeholder="請選擇" filterable>
              <el-option v-for="(district, index) in districts" :key="index" :label="district.name"
                :value="district.name"> </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :md="12">
          <el-form-item label="地址" prop="location.address">
            <el-input v-model="submitData.location.address" />
          </el-form-item>
        </el-col>
      </el-row>
    </template>
    <div class="only-bottom-line"></div>

    <el-form-item label="分店簡介" prop="description">
      <el-input v-model="submitData.description" type="textarea" :autosize="{ minRows: 4 }"
        class="is-border is-rounded bg-white" />
    </el-form-item>

    <el-form-item label="注意事項" prop="notice">
      <el-input v-model="submitData.notice" type="textarea" :autosize="{ minRows: 4 }"
        class="is-border is-rounded bg-white" />
    </el-form-item>
    <div class="only-bottom-line" style="margin-top:14px;margin-bottom: 24px;"></div>
    <div :class="$style.atmInfo">
      <h4 data-tour-text="" class="form-block-title">匯款資訊 </h4>
      <div class="atmBtn">
        <el-button class="is-round mb-3" @click="setDefaultMerchant">和商店設定相同
        </el-button>
        <span class="text-muted spanIf">（如需使用金流服務，請與{{ $t('APP_NAME') }} 聯繫
          (02)2531-6628）</span>
      </div>
    </div>
    <el-row :gutter="20">
      <el-col :md="12">
        <el-form-item label="匯款銀行" prop="atmBank">
          <el-select v-model="submitData.atmBank" placeholder="請選擇匯款銀行" :popper-append-to-body="false"
            class="bg-white is-rounded is-border">
            <el-option v-for="item in taiwanBankCode" :key="item.code" :value="`${item.code}-${item.name}`">
              {{ `${item.code}-${item.name}` }}
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :md="12">
        <el-form-item label="匯款帳號" prop="atmAccount">
          <el-input v-model="submitData.atmAccount" class="bg-white is-rounded is-border" />
        </el-form-item>
      </el-col>
      <el-col :md="24">
        <el-form-item label="戶名" prop="atmAccountName">
          <el-input v-model="submitData.atmAccountName" class="bg-white is-rounded is-border" />
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
</template>
<style lang="scss" module>
@import '@design';

%img-size {
  width: calc(33.333333% - 10px);
  height: 175px;

  @include max-sm {
    width: calc(100% - 10px);
  }
}

:global {
  :local(.upload) {
    margin: 0 -10px;
    border-top: none !important;

    >div {
      @extend %img-size;
    }

    .image-and-action {
      @extend %img-size;

      &+div {
        @extend %img-size;
      }
    }
  }
}

.editProduct {
  padding: 2.227px 20px 18px;
  background-color: white;

  :global {
    .openService {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
  }
}

.atmInfo {
  display: flex;
  flex-direction: column;

  >h4 {
    margin-right: 12px;
  }

  :global {
    .spanIf {
      margin-left: 10px;
    }

    .atmBtn {
      display: flex;
      align-items: center;
    }
  }
}
</style>